import { StepState } from './types';
/**
 * Get step's state: active, completed, or pending
 */
export function getStepState(stepIndex, currentStep) {
    if (stepIndex === currentStep) {
        return StepState.active;
    }
    else if (stepIndex < currentStep) {
        return StepState.completed;
    }
    return StepState.pending;
}
